/**
 * landing-range.js
 * Gère les interactions de la section landing-range :
 *  - Accordéons LP (advantages)
 *  - Carousels Glide (advantages, zoom synchronisé image/texte, products, related)
 *  - Lightbox vidéo (liens .lp-lightbox-link → iframe en overlay)
 */

(function () {
  'use strict';

  if (window.__lpRangeInit) return;
  window.__lpRangeInit = true;

  /* ──────────────────────────────────────────────────────────────────
   * Accordéons
   * ────────────────────────────────────────────────────────────────── */
  function initAccordions() {
    document.querySelectorAll('[data-lp-accordion]').forEach(function (item) {
      var toggle = item.querySelector('.lp-accordion__toggle');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  /* ──────────────────────────────────────────────────────────────────
   * Carousels simples (advantages, products, related)
   * ────────────────────────────────────────────────────────────────── */
  function initSimpleGlide(el, options) {
    if (!el || typeof Glide === 'undefined') return null;
    var slides = el.querySelectorAll('.glide__slide');
    if (slides.length === 0) return null;

    try {
      return new Glide(el, options).mount();
    } catch (e) {
      return null;
    }
  }

  function initAdvantagesSliders() {
    document.querySelectorAll('.glide--lp-adv').forEach(function (el) {
      var slides = el.querySelectorAll('.glide__slide');
      if (slides.length <= 1) return;
      initSimpleGlide(el, {
        type: 'carousel',
        autoplay: 4000,
        hoverpause: true,
        animationDuration: 500,
      });
    });
  }

  function initProductsSliders() {
    document.querySelectorAll('.glide--lp-products').forEach(function (el) {
      var slides = el.querySelectorAll('.glide__slide');
      if (slides.length === 0) return;
      initSimpleGlide(el, {
        type: 'slider',
        perView: 3,
        gap: 20,
        bound: true,
        breakpoints: {
          1024: { perView: 2 },
          640: { perView: 1 },
        },
      });
    });
  }

  function initRelatedSliders() {
    document.querySelectorAll('.glide--lp-related').forEach(function (el) {
      var slides = el.querySelectorAll('.glide__slide');
      if (slides.length === 0) return;
      initSimpleGlide(el, {
        type: 'slider',
        perView: 4,
        gap: 10,
        bound: true,
        breakpoints: {
          1024: { perView: 2 },
          640: { perView: 1 },
        },
      });
    });
  }

  /* ──────────────────────────────────────────────────────────────────
   * Zoom : deux carousels synchronisés (images + textes)
   * ────────────────────────────────────────────────────────────────── */
  function initZoomSliders() {
    /* Cherche toutes les sections zoom (identifiées par un id glide-zoom-txt-*) */
    document.querySelectorAll('[id^="glide-zoom-txt-"]').forEach(function (txtEl) {
      var blockId = txtEl.id.replace('glide-zoom-txt-', '');
      var imgEl = document.getElementById('glide-zoom-img-' + blockId);

      if (!txtEl || typeof Glide === 'undefined') return;

      var totalSlides = txtEl.querySelectorAll('.glide__slide').length;
      if (totalSlides === 0) return;

      var txtGlide = null;
      var imgGlide = null;
      var syncing = false;

      try {
        txtGlide = new Glide(txtEl, {
          type: 'slider',
          perView: 1,
          gap: 40,
          bound: true,
        }).mount();
      } catch (e) { return; }

      if (imgEl && imgEl.querySelectorAll('.glide__slide').length > 0) {
        try {
          imgGlide = new Glide(imgEl, {
            type: 'slider',
            perView: 1,
            gap: 0,
            bound: true,
            //dragThreshold: false,
            //swipeThreshold: false,
          }).mount();
        } catch (e) { /* image carousel optional */ }
      }

      /* Synchronisation bidirectionnelle */
      if (imgGlide) {
        txtGlide.on('run', function () {
          if (syncing) return;
          syncing = true;
          imgGlide.go('=' + txtGlide.index);
          syncing = false;
        });

        imgGlide.on('run', function () {
          if (syncing) return;
          syncing = true;
          txtGlide.go('=' + imgGlide.index);
          syncing = false;
        });
      }
    });
  }

  /* ──────────────────────────────────────────────────────────────────
   * Lightbox vidéo
   * Ouvre YouTube/Vimeo dans une iframe plein écran.
   * ────────────────────────────────────────────────────────────────── */
  function buildEmbedUrl(url) {
    /* YouTube */
    var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0';

    /* Vimeo */
    var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';

    return url;
  }

  function openLightbox(url) {
    var embedUrl = buildEmbedUrl(url);

    var overlay = document.createElement('div');
    overlay.className = 'lp-lightbox-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Lecteur vidéo');

    var close = document.createElement('button');
    close.className = 'lp-lightbox-close';
    close.setAttribute('aria-label', 'Fermer la vidéo');
    close.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

    var frame = document.createElement('iframe');
    frame.className = 'lp-lightbox-iframe';
    frame.src = embedUrl;
    frame.allow = 'autoplay; fullscreen; picture-in-picture';
    frame.allowFullscreen = true;

    overlay.appendChild(close);
    overlay.appendChild(frame);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    function destroy() {
      frame.src = '';
      document.body.removeChild(overlay);
      document.body.style.overflow = '';
    }

    close.addEventListener('click', destroy);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) destroy();
    });
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') { destroy(); document.removeEventListener('keydown', onKey); }
    });
  }

  function initLightbox() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.lp-lightbox-link');
      if (!link) return;
      e.preventDefault();
      var url = link.getAttribute('href');
      if (url) openLightbox(url);
    });
  }

  /* ──────────────────────────────────────────────────────────────────
   * Init
   * ────────────────────────────────────────────────────────────────── */
  function init() {
    initAccordions();
    initAdvantagesSliders();
    initZoomSliders();
    initProductsSliders();
    initRelatedSliders();
    initLightbox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
